//Remove these hardcoded values and use service object instead before production. bug logged to track this item
export const translatorAddinId = "27797656-b5ea-4db3-8043-0230f0b4d6d6";
export const addinCommandId = "translate.buttonDesktop1_1";
export const endpointUrl = "https://ogma.osi.office.net/outlooktranslatorapp/desktop";
export const appDomainRoot = "https://ogma.osi.office.net";
export const appDomain = "https://ogma.osi.office.net/outlooktranslatorapp/desktop";
export const manifestVersion = "1.0.8.1";
export const iconUrl = "https://ogma.osi.office.net/outlooktranslatorapp/Images/TranslateIcon64x64.png";
export const addinDisplayName = "Translator";
export const addinDescription = "Help you translate messages in your preferred language across devices";
export const providerName = "Microsoft";
export const highResolutionIconUrl = "https://ogma.osi.office.net/outlooktranslatorapp/Images/TranslateIcon128x128.png";
